/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbPayorSourcePage } from './HchbPayorSourcePage';
import {
    HchbPayorSourcePageFromJSON,
    HchbPayorSourcePageFromJSONTyped,
    HchbPayorSourcePageToJSON,
    HchbPayorSourcePageToJSONTyped,
} from './HchbPayorSourcePage';

/**
 * 
 * @export
 * @interface FindAllHchbPayorSources200Response
 */
export interface FindAllHchbPayorSources200Response {
    /**
     * 
     * @type {HchbPayorSourcePage}
     * @memberof FindAllHchbPayorSources200Response
     */
    data?: HchbPayorSourcePage;
}

/**
 * Check if a given object implements the FindAllHchbPayorSources200Response interface.
 */
export function instanceOfFindAllHchbPayorSources200Response(value: object): value is FindAllHchbPayorSources200Response {
    return true;
}

export function FindAllHchbPayorSources200ResponseFromJSON(json: any): FindAllHchbPayorSources200Response {
    return FindAllHchbPayorSources200ResponseFromJSONTyped(json, false);
}

export function FindAllHchbPayorSources200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllHchbPayorSources200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : HchbPayorSourcePageFromJSON(json['data']),
    };
}

export function FindAllHchbPayorSources200ResponseToJSON(json: any): FindAllHchbPayorSources200Response {
    return FindAllHchbPayorSources200ResponseToJSONTyped(json, false);
}

export function FindAllHchbPayorSources200ResponseToJSONTyped(value?: FindAllHchbPayorSources200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': HchbPayorSourcePageToJSON(value['data']),
    };
}

